"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var React = require("react");
var _ = require("underscore");
var classNames_1 = require("../../../utilities/classNames");
var formCore_1 = require("../formCore");
var validationWrapper_1 = require("../validationWrapper");
var icon_1 = require("./../../display/icon");
var TagInput = /** @class */ (function (_super) {
    tslib_1.__extends(TagInput, _super);
    function TagInput(props) {
        var _this = _super.call(this, props) || this;
        _this.notifyTagsChange = function (tags) {
            _this.setState({ tags: tags, suggestions: [] });
            _this.props.onChange(tags);
        };
        _this.notifySuggestionsChange = function (suggestions) {
            if (suggestions === void 0) { suggestions = []; }
            _this.setState({ suggestions: suggestions, suggestionIndex: -1 });
        };
        _this.state = { tags: [], suggestions: [], suggestionIndex: -1 };
        return _this;
    }
    TagInput.prototype.focus = function () {
        if (this.input) {
            this.input.focus();
        }
    };
    TagInput.prototype.blur = function () {
        if (this.input) {
            this.input.blur();
        }
    };
    TagInput.prototype.componentWillReceiveProps = function (nextProps) {
        if (nextProps.value !== this.props.value) {
            this.setState({ tags: nextProps.value || [] });
        }
    };
    TagInput.prototype.componentWillMount = function () {
        this.setState({ tags: this.props.value || [] });
    };
    TagInput.prototype.findOne = function (haystack, arr) {
        return arr.some(function (v) { return haystack.indexOf(v) >= 0; });
    };
    TagInput.prototype.onKeyUp = function (e) {
        var input = e.target;
        // tslint:disable-next-line:no-string-literal
        var value = input["value"];
        switch (e.keyCode) {
            case 40: // ArrowDown
            case 38: // ArrowUp}
                return;
            case 13:
                if (value) {
                    if (this.state.tags.indexOf(value) === -1) {
                        var tags = this.state.tags.concat([value]);
                        this.notifyTagsChange(tags);
                    }
                    // tslint:disable-next-line:no-string-literal
                    input["value"] = "";
                    return;
                }
                break;
        }
        if (value) {
            this.notifySuggestionsChange(this.filterSuggestions(value));
        }
        else {
            this.notifySuggestionsChange();
        }
    };
    TagInput.prototype.makeComparison = function (value) {
        return value ? value.trim().toLowerCase() : "";
    };
    TagInput.prototype.filterSuggestions = function (value) {
        var _this = this;
        value = this.makeComparison(value);
        if (!value) {
            return [];
        }
        var filteredSuggestions = this.props.suggestions.filter(function (s) { return _this.makeComparison(s).lastIndexOf(value, 0) === 0; });
        return filteredSuggestions.filter(function (s) { return _this.state.tags.indexOf(s) === -1; });
    };
    TagInput.prototype.onKeyDown = function (e) {
        var input = e.target;
        // tslint:disable-next-line:no-string-literal
        var value = input["value"];
        var _a = this.state, suggestionIndex = _a.suggestionIndex, suggestions = _a.suggestions;
        switch (e.keyCode) {
            case 8: // delete
                if (this.state.tags.length !== 0 && !value) {
                    var tags = _.clone(this.state.tags);
                    tags.splice(-1, 1);
                    this.notifyTagsChange(tags);
                }
                break;
            case 40: // ArrowDown
                if (suggestionIndex < suggestions.length - 1) {
                    this.setState({ suggestionIndex: suggestionIndex + 1 });
                }
                e.preventDefault();
                break;
            case 38: // ArrowUp}
                if (suggestionIndex > -1) {
                    this.setState({ suggestionIndex: suggestionIndex - 1 });
                }
                e.preventDefault();
                break;
            case 13:
                var suggestion = suggestions[suggestionIndex];
                if (suggestion) {
                    this.addTag(suggestion);
                }
                break;
        }
    };
    TagInput.prototype.addTag = function (tag) {
        var tags = this.state.tags.concat([tag]);
        this.notifyTagsChange(tags);
        this.input.value = "";
        this.input.focus();
    };
    TagInput.prototype.removeTag = function (index) {
        var tags = _.clone(this.state.tags);
        tags.splice(index, 1);
        this.notifyTagsChange(tags);
        this.input.focus();
    };
    TagInput.prototype.renderSuggestions = function (suggestions) {
        var _this = this;
        if (!suggestions || !suggestions.length) {
            return null;
        }
        return React.createElement("div", { className: "suggestions" }, suggestions.map(function (s, i) { return React.createElement("div", { key: s, className: classNames_1.ClassHelpers.classNames({ selected: i === _this.state.suggestionIndex }), onClick: function () { return _this.addTag(s); } }, s); }));
    };
    TagInput.prototype.render = function () {
        var _this = this;
        var validationMessage = formCore_1.DataValidationMessage.get(this.props);
        var classes = classNames_1.ClassHelpers.classNames("armstrong-input", "tag-input", this.props.className, {
            "show-validation": this.props.validationMode !== "none" && validationMessage,
        });
        return (React.createElement("div", { className: classes },
            this.state.tags.map(function (t, i) { return (React.createElement("div", { key: t, className: "tag" },
                t,
                React.createElement(icon_1.Icon, { icon: icon_1.Icon.Icomoon.cross, onClick: function () { return _this.removeTag(i); } }))); }),
            React.createElement("input", { onKeyDown: function (e) { return _this.onKeyDown(e); }, ref: function (r) { return (_this.input = r); }, onKeyUp: function (e) { return _this.onKeyUp(e); }, type: "text" }),
            this.renderSuggestions(this.state.suggestions),
            React.createElement(validationWrapper_1.ValidationLabel, { message: validationMessage, mode: this.props.validationMode })));
    };
    TagInput.defaultProps = {};
    return TagInput;
}(React.Component));
exports.TagInput = TagInput;
